import { styles } from '@app/services/app-styles.service';

const listbox = {
    root: {
        background: styles().layer,
    },
};

export default listbox;
